import React, {useEffect, useState} from "react"

import {NoActivities} from "./NoActivities"
import {List} from "./List"

import {api} from "@indebted/api"
import type {CustomerActivitiesResponse} from "@indebted/api"
import {LoadingPage} from "@indebted/components/Loading"

type State = {status: "loading"} | {status: "loaded"; activities: CustomerActivitiesResponse} | {status: "error"}

function Activities({customerID}: {customerID: string}) {
	const [state, setState] = useState<State>({status: "loading"})

	useEffect(() => {
		api.customer
			.activities(customerID)
			.then((activities) => setState({status: "loaded", activities}))
			.catch(() => setState({status: "error"}))
	}, [customerID])

	if (state.status === "loading") return <LoadingPage />
	if (state.status === "error") return <NoActivities>Something went wrong</NoActivities>
	if (state.activities.Activities.length === 0) return <NoActivities>No activities</NoActivities>

	return <List activities={state.activities} customerID={customerID} />
}

export {Activities}
